const regex = /\/c\/\d+/;

function removeClientFromPathname(pathname) {
    return pathname.replace(regex, '');
}

export default removeClientFromPathname;
